import React, {useRef} from "react";
import useMoveMutation from "../libs/MoveHandler";
import Avatar from "./Avatar";
import numeral from "numeral";
import {useParams} from "react-router-dom";

function Mail({msg, first = true, setOpenReply}) {
    const {slug} = useParams()
    const { moveHandle, mutation } = useMoveMutation();

    const mailBodyRef = useRef(null);
    const viewToggle = () => {
        if(!first){
            mailBodyRef.current.classList.toggle('d-none');
        }
    }

    return (
        <div className="mailcontent-item">
            <div className="mailcontent-header" onClick={viewToggle}>
                <div className="mail-avatar">
                    <Avatar row={msg.from}/>
                </div>
                <div className="mailcontent-sender">
                    <h6>
                        {msg.from.display_name}
                        <span>&lt;{msg.from.member_type}&gt;</span> {/*<span>&lt;{msg.from.username}&gt;</span>*/}
                    </h6>
                    <p>to: {msg.to.display_name}</p>
                </div>
                {/* mail-sender */}
                <div className="mailcontent-time">
                    <span className="msg-date">{msg.date}</span><span className="msg-ago">({msg.ago})</span>
                </div>
                {!['sent'].includes(slug) &&
                <nav className={`nav ${(mutation.isLoading ? 'isLoading' : '')}`}>
                    <a href="#" onClick={(el) => moveHandle(el, 'stared', msg.id)}
                       className={`nav-link mail-star ${(msg?.labels.find((l) => l.slug === 'stared') ? 'active' : '')}`}
                       data-bs-toggle="tooltip" title="Not Starred" aria-label="Not Starred">
                        <i className="ri-star-line"></i>
                        <i className="ri-star-fill"></i>
                    </a>
                    <a href="#" className="nav-link" data-bs-toggle="tooltip" title="Reply" aria-label="Reply" onClick={() => setOpenReply(true)}>
                        <i className="ri-reply-line"/>
                    </a>
                    <a href="#" className="nav-link" data-bs-toggle="tooltip" title="More" aria-label="More">
                        <i className="ri-more-2-fill"/>
                    </a>
                </nav>
                }
            </div>
            {msg?.labels && msg.labels.filter((l) => l.slug !== 'stared').length > 0 &&
                <div className="mail-labels">
                    <i className="ri-price-tag-line"></i>
                    {msg?.labels.map((label, i) => (label.slug === 'stared' ? '' :
                        <span key={i} className="badge" style={{backgroundColor: label.color}}>
                            <span>{label.label}</span>
                            <i className="ms-2 ri-close-line border-start ps-1" data-bs-toggle="tooltip" title="Delete" onClick={(el) => moveHandle(el, label.slug, msg.id, true)}/>
                        </span>))}
                </div>
            }
            <div className={`mailcontent-body ${(!first ? 'd-none' : '')}`} ref={mailBodyRef}>
                <div dangerouslySetInnerHTML={{__html: msg.message}}/>
                {msg.attachments &&
                    <>
                        <hr/>
                        <label className="mailcontent-label">{numeral(msg.attachments.length).format('0,0')} Attachments</label>
                        <div className="attachment-group">
                            {msg.attachments?.map((file) => {
                                return <div className="attachment-item">
                                    <div className="attachment-icon text-primary">
                                        {/*<i className="ri-file-zip-line"></i>*/}
                                        <a href={file.file} download="true" target="_blank" className="text-decoration-none">
                                            <i className="ri-file-download-line"></i>
                                        </a>
                                    </div>
                                    <div className="attachment-body">
                                        <h6><a href={file.file} download={"true"} target="_blank">{file.name}</a></h6>
                                        <span>{file?.size}</span>
                                    </div>
                                </div>
                            })}
                        </div>
                    </>
                }
            </div>
        </div>
    )
}


export default Mail;